import common from "./common.sr.json";

const translations = { common };

export default translations;
